import { render, staticRenderFns } from "./FindPlans.vue?vue&type=template&id=64c28d87&scoped=true"
import script from "./FindPlans.vue?vue&type=script&lang=js"
export * from "./FindPlans.vue?vue&type=script&lang=js"
import style0 from "./FindPlans.vue?vue&type=style&index=0&id=64c28d87&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c28d87",
  null
  
)

export default component.exports